import React, { useState } from 'react';
import { Box, Paper, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import styles from './ImportFAQ.module.css';

const ImportFAQ = () => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            question: 'Quanto tempo leva para os pacientes serem importados?',
            answer: 'O processo de importação geralmente leva de 24 a 48 horas úteis após o recebimento da planilha. Você receberá uma confirmação por email quando a importação for concluída.'
        },
        {
            question: 'O que acontece se eu enviar dados duplicados?',
            answer: 'O sistema verifica automaticamente por CPFs duplicados. Pacientes que já existem no sistema não serão duplicados, mas suas informações podem ser atualizadas se houver diferenças.'
        },
        {
            question: 'Posso importar pacientes de outro sistema?',
            answer: 'Sim, você pode exportar os dados de pacientes do seu sistema atual para uma planilha Excel e depois adaptá-los ao nosso modelo de importação.'
        },
        {
            question: 'Existe um limite de pacientes que posso importar?',
            answer: 'Não há limite específico, mas recomendamos dividir importações muito grandes (acima de 1000 pacientes) em múltiplos arquivos para facilitar o processamento.'
        },
        {
            question: 'O que acontece se houver erros na planilha?',
            answer: 'Nossa equipe verificará a planilha e, caso encontre erros, entrará em contato com você para correções antes de prosseguir com a importação.'
        }
    ];

    return (
        <Paper elevation={1} className={styles.container}>
            <Box sx={{ p: 3 }}>
                <div className={styles.headerContainer}>
                    <div className={styles.iconContainer}>
                        <QuestionAnswerOutlinedIcon className={styles.headerIcon} />
                    </div>
                    <Typography variant="h6" className={styles.sectionTitle}>
                        Perguntas Frequentes
                    </Typography>
                </div>
                
                <div className={styles.faqList}>
                    {faqs.map((faq, index) => (
                        <Accordion 
                            key={index}
                            expanded={expanded === `panel${index}`}
                            onChange={handleChange(`panel${index}`)}
                            className={styles.faqItem}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon className={styles.expandIcon} />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                                className={styles.faqQuestion}
                            >
                                <div className={styles.questionContainer}>
                                    <HelpOutlineIcon className={styles.questionIcon} />
                                    <Typography variant="subtitle1" className={styles.questionText}>
                                        {faq.question}
                                    </Typography>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails className={styles.faqAnswer}>
                                <Typography variant="body2">
                                    {faq.answer}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
                
                <div className={styles.decorationCircle}></div>
            </Box>
        </Paper>
    );
};

export default ImportFAQ;